import React from 'react';

const Icon = ({ children }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {children}
    </svg>
);

export const BringToFrontIcon = () => (
    <Icon><rect x="8" y="8" width="12" height="12" rx="2" fill="currentColor" stroke="none" /><path d="M4 16V6a2 2 0 0 1 2-2h10" /></Icon>
);
export const SendToBackIcon = () => (
    <Icon><rect x="4" y="4" width="12" height="12" rx="2" fill="currentColor" stroke="none" /><path d="M20 8v10a2 2 0 0 1-2 2H8" /></Icon>
);
export const DuplicateIcon = () => (
    <Icon><rect x="9" y="9" width="11" height="11" rx="2" /><path d="M15 5H6a2 2 0 0 0-2 2v9" /></Icon>
);
export const GroupIcon = () => (
    <Icon><rect x="3" y="3" width="18" height="18" rx="2" strokeDasharray="3 2" /><rect x="7" y="7" width="4" height="4" rx="1" /><rect x="13" y="13" width="4" height="4" rx="1" /></Icon>
);
export const UngroupIcon = () => (
    <Icon><rect x="3" y="3" width="8" height="8" rx="1.5" /><rect x="13" y="13" width="8" height="8" rx="1.5" /><path d="M13 7h3a1 1 0 0 1 1 1v3" /></Icon>
);
export const PropertiesIcon = () => (
    <Icon><path d="M4 7h10M18 7h2M4 17h4M12 17h8" /><circle cx="16" cy="7" r="2" /><circle cx="10" cy="17" r="2" /></Icon>
);
export const DeleteIcon = () => (
    <Icon><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-12M9 7V4h6v3" /></Icon>
);
